import React from "react";
import { useSelector } from "react-redux";
import classes from './StudentsAnswersPrecents.module.css'

const StudentsAnswersPrecents = ({ studentsCount, answersCount, answerType }) => {
    const texts = useSelector((state) => state.translate.texts);

    return (
        <div className={`${classes.StudentsAnswersPrecents} ${classes[answerType]}`}>
                <h1 className={classes.AnswerCount}>{answersCount}</h1>
                <p className={classes.AnswerData}>
                    {texts.students}
                    {` (${(((answersCount / studentsCount) * 100) || 0).toFixed(0)}%) `}
                    {texts[answerType]}
                </p>
        </div>
    )
}

export default StudentsAnswersPrecents